import { z } from 'zod';
import { ValidatorUtils } from '../utils/ValidatorUtils';

export const ContentTypeEnumSchema = z.enum([
    'text/plain',
    'text/markdown',
    'application/json',
    'application/vnd.amazonaws.connect.message.interactive.response',
    'application/vnd.amazonaws.connect.event.chat.rehydrated',
    'application/vnd.amazonaws.connect.event.typing',
    'application/vnd.amazonaws.connect.event.message.read',
    'application/vnd.amazonaws.connect.event.message.delivered',
    'application/vnd.amazonaws.connect.event.participant.joined',
    'application/vnd.amazonaws.connect.event.participant.left',
    'application/vnd.amazonaws.connect.event.participant.returned',
    'application/vnd.amazonaws.connect.event.transfer.succeeded',
    'application/vnd.amazonaws.connect.event.transfer.failed',
    'application/vnd.amazonaws.connect.message.interactive',
    'application/vnd.amazonaws.connect.event.chat.ended',
    'application/vnd.amazonaws.connect.event.participant.autodisconnection',
    'application/vnd.amazonaws.connect.event.participant.idle',
    'application/vnd.amazonaws.connect.event.message.read',
    'application/vnd.amazonaws.connect.event.message.delivered',
    'application/vnd.amazonaws.connect.event.message.metadata',
    'application/chat.event.message.pending',
    'application/chat.event.stream',
    'application/chat.event.message.error',
]);

export const JsonContentTypeEnumSchema = z.enum([
    'application/chat.json.v1',
    'application/chat.event.session.started',
    'application/chat.event.session.ended',
    'application/chat.event.feedback.requested',
    'application/chat.event.feedback.thumbs.up',
    'application/chat.event.feedback.thumbs.down',
    'application/chat.event.end.request',
    'application/chat.message.sherlock.response',
    'application/chat.message.sherpa.response',
    'application/chat.message.vqa.response',
]);

export const CampaignEnumSchema = z.enum([
    'RC3',
    'RC3_uk',
    'ACEC_SOCIAL',
    'ACEC_THEFT',
    'ACEC_Ring_Intercom_UK',
    'ACEC_Ring_Intercom_IT',
    'ACEC_Ring_Intercom_NL',
    'ACEC_Ring_Intercom_ES',
    'ACEC_Ring_Intercom_FR',
    'ACEC_Ring_Intercom_DE',
    'ACEC_ANZ',
    'ACEC_DE',
    'ACEC_ES',
    'ACEC_FR',
    'ACEC_IT',
    'ACEC_JP',
    'ACEC_LATAM',
    'ACEC_NL',
    'ACEC_UK',
    'ACEC_US',
]);

export enum Market {
    deDE = 'de-DE',
    enAU = 'en-AU',
    enGB = 'en-GB',
    enUS = 'en-US',
    esES = 'es-ES',
    esLATAM = 'es-LATAM',
    frFR = 'fr-FR',
    itIT = 'it-IT',
    jaJP = 'ja-JP',
    nlNL = 'nl-NL',
}

export const MarketEnumSchema = z.nativeEnum(Market);

export enum Agent {
    SHERLOCK = 'SHERLOCK',
    SHERPA = 'SHERPA',
    VQA = 'VQA',
}

export const AgentSchema = z.nativeEnum(Agent);

const ServerAgentLists: Record<string, string> = {
    APP_AGENTS: [Agent.SHERLOCK].join(','),
    AUTHED_WEB_AGENTS: [Agent.SHERLOCK].join(','),
    UNAUTHED_WEB_AGENTS: [Agent.SHERLOCK].join(','),
};

export const AgentsStringSchema = z.string()
    .transform((s) => ServerAgentLists[s] || s)
    .pipe(z.string().max(50))
    .refine(
        value => value.split(',')
            .map(item => item.trim())
            .every(item => AgentSchema.safeParse(item).success),
        { message: 'Invalid agent in agent string' },
    )
    .transform(
        value => [...new Set(value.split(',')
            .map(item => item.trim()))].join(','),
    );

export const MessageAttributesSchema = z.record(
    z.string().max(20),
    z.pipeline(
        z.string().transform((s) => ValidatorUtils.sanitizeString(s)),
        z.string().max(80),
    ),
).refine(
    (attrs) => Object.keys(attrs).length <= 10,
    { message: 'Maximum 10 attributes allowed' },
);
